// Generated by purs version 0.11.7
"use strict";
var Control_Applicative = require("../Control.Applicative");
var Control_Apply = require("../Control.Apply");
var Control_Bind = require("../Control.Bind");
var Control_Monad_Eff = require("../Control.Monad.Eff");
var Control_Monad_Eff_Console = require("../Control.Monad.Eff.Console");
var Control_Semigroupoid = require("../Control.Semigroupoid");
var DOM = require("../DOM");
var Data_Array = require("../Data.Array");
var Data_Eq = require("../Data.Eq");
var Data_Function = require("../Data.Function");
var Data_Functor = require("../Data.Functor");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra");
var Data_Int = require("../Data.Int");
var Data_Ord = require("../Data.Ord");
var Data_Ring = require("../Data.Ring");
var Data_Semiring = require("../Data.Semiring");
var Data_Unit = require("../Data.Unit");
var FRP = require("../FRP");
var FRP_Behavior = require("../FRP.Behavior");
var FRP_Behavior_Keyboard = require("../FRP.Behavior.Keyboard");
var FRP_Event = require("../FRP.Event");
var FRP_Event_Time = require("../FRP.Event.Time");
var Levels = require("../Levels");
var Partial_Unsafe = require("../Partial.Unsafe");
var Prelude = require("../Prelude");
var PrestoDOM_Core = require("../PrestoDOM.Core");
var PrestoDOM_Elements = require("../PrestoDOM.Elements");
var PrestoDOM_Properties = require("../PrestoDOM.Properties");
var PrestoDOM_Types = require("../PrestoDOM.Types");
var PrestoDOM_Types_DomAttributes = require("../PrestoDOM.Types.DomAttributes");
var PrestoDOM_Util = require("../PrestoDOM.Util");
var Sokoban_Level = require("../Sokoban.Level");
var Sokoban_Types = require("../Sokoban.Types");
var resetGame = {
    world: Sokoban_Level.createWorld(Levels["levels"][0]),
    canMove: true,
    direction: Sokoban_Types.NONE.value,
    currentLevel: 0
};
var renderGameScreen = function (state) {
    return Sokoban_Level.renderLevel(state);
};
var world = function (state) {
    return PrestoDOM_Elements.linearLayout([ PrestoDOM_Properties.id_("container"), PrestoDOM_Properties.width(PrestoDOM_Types_DomAttributes.Match_Parent.value), PrestoDOM_Properties.height(PrestoDOM_Types_DomAttributes.Match_Parent.value), PrestoDOM_Properties.gravity("center"), PrestoDOM_Properties.orientation("vertical"), PrestoDOM_Properties.background("#2d3436") ])([ PrestoDOM_Elements.linearLayout([ PrestoDOM_Properties.id_("gameContainer"), PrestoDOM_Properties.width(new PrestoDOM_Types_DomAttributes.V(state.world.width + 50 | 0)), PrestoDOM_Properties.height(new PrestoDOM_Types_DomAttributes.V(state.world.height + 50 | 0)), PrestoDOM_Properties.gravity("center") ])([ renderGameScreen(state) ]) ]);
};
var interpolate = function (v) {
    var roundFunc = function (v0) {
        return function (v1) {
            var $26 = v0 <= v1;
            if ($26) {
                return Data_Int.ceil;
            };
            return Data_Int.floor;
        };
    };
    var calc = function (v0) {
        return function (v1) {
            return roundFunc(v0)(v1)((1.0 - 0.15) * Data_Int.toNumber(v0) + 0.15 * Data_Int.toNumber(v1));
        };
    };
    var $27 = {};
    for (var $28 in v) {
        if ({}.hasOwnProperty.call(v, $28)) {
            $27[$28] = v[$28];
        };
    };
    $27.x = calc(v.x)(v.nextPos.value0);
    $27.y = calc(v.y)(v.nextPos.value1);
    return $27;
};
var getNextPos = function (entity) {
    return function (direction) {
        return function (steps) {
            if (direction instanceof Sokoban_Types.UP) {
                return new Sokoban_Types.Coord(entity.x, entity.y - (50 * steps | 0) | 0);
            };
            if (direction instanceof Sokoban_Types.LEFT) {
                return new Sokoban_Types.Coord(entity.x - (50 * steps | 0) | 0, entity.y);
            };
            if (direction instanceof Sokoban_Types.DOWN) {
                return new Sokoban_Types.Coord(entity.x, entity.y + (50 * steps | 0) | 0);
            };
            if (direction instanceof Sokoban_Types.RIGHT) {
                return new Sokoban_Types.Coord(entity.x + (50 * steps | 0) | 0, entity.y);
            };
            return new Sokoban_Types.Coord(entity.x, entity.y);
        };
    };
};
var updateGame = function (state) {
    var moveEntity = function (entity) {
        return function (direction) {
            var $34 = {};
            for (var $35 in entity) {
                if ({}.hasOwnProperty.call(entity, $35)) {
                    $34[$35] = entity[$35];
                };
            };
            $34.nextPos = getNextPos(entity)(direction)(1);
            return $34;
        };
    };
    var updateBag = function (s) {
        return function (bag) {
            var $37 = Data_Eq.eq(Sokoban_Types.eqCoord)(s.world.soko.nextPos)(new Sokoban_Types.Coord(bag.x, bag.y));
            if ($37) {
                return moveEntity(bag)(s.direction);
            };
            return bag;
        };
    };
    var updateBags = function (s) {
        var $41 = {};
        for (var $42 in s) {
            if ({}.hasOwnProperty.call(s, $42)) {
                $41[$42] = s[$42];
            };
        };
        $41.world = (function () {
            var $38 = {};
            for (var $39 in s.world) {
                if ({}.hasOwnProperty.call(s.world, $39)) {
                    $38[$39] = s["world"][$39];
                };
            };
            $38.bags = Data_Functor.map(Data_Functor.functorArray)(updateBag(s))(s.world.bags);
            return $38;
        })();
        return $41;
    };
    var interpolateSoko = function (s) {
        var $47 = {};
        for (var $48 in s) {
            if ({}.hasOwnProperty.call(s, $48)) {
                $47[$48] = s[$48];
            };
        };
        $47.world = (function () {
            var $44 = {};
            for (var $45 in s.world) {
                if ({}.hasOwnProperty.call(s.world, $45)) {
                    $44[$45] = s["world"][$45];
                };
            };
            $44.soko = interpolate(s.world.soko);
            return $44;
        })();
        return $47;
    };
    var interpolateBags = function (s) {
        var $53 = {};
        for (var $54 in s) {
            if ({}.hasOwnProperty.call(s, $54)) {
                $53[$54] = s[$54];
            };
        };
        $53.world = (function () {
            var $50 = {};
            for (var $51 in s.world) {
                if ({}.hasOwnProperty.call(s.world, $51)) {
                    $50[$51] = s["world"][$51];
                };
            };
            $50.bags = Data_Functor.map(Data_Functor.functorArray)(interpolate)(s.world.bags);
            return $50;
        })();
        return $53;
    };
    var hasWall = function (coord) {
        return Data_Array.length(Data_Array.filter(function (wall) {
            return Data_Eq.eq(Sokoban_Types.eqCoord)(coord)(new Sokoban_Types.Coord(wall.x, wall.y));
        })(state.world.walls)) > 0;
    };
    var hasBag = function (coord) {
        return Data_Array.length(Data_Array.filter(function (bag) {
            return Data_Eq.eq(Sokoban_Types.eqCoord)(coord)(new Sokoban_Types.Coord(bag.x, bag.y));
        })(state.world.bags)) > 0;
    };
    var hasAny = function (coord) {
        return hasBag(coord) || hasWall(coord);
    };
    var updateSoko = function (s) {
        var $56 = hasWall(getNextPos(s.world.soko)(s.direction)(1));
        if ($56) {
            return s;
        };
        var $57 = hasBag(getNextPos(s.world.soko)(s.direction)(1)) && hasAny(getNextPos(s.world.soko)(s.direction)(2));
        if ($57) {
            return s;
        };
        var $61 = {};
        for (var $62 in s) {
            if ({}.hasOwnProperty.call(s, $62)) {
                $61[$62] = s[$62];
            };
        };
        $61.world = (function () {
            var $58 = {};
            for (var $59 in s.world) {
                if ({}.hasOwnProperty.call(s.world, $59)) {
                    $58[$59] = s["world"][$59];
                };
            };
            $58.soko = moveEntity(s.world.soko)(s.direction);
            return $58;
        })();
        return $61;
    };
    var entityToCoord = function (e) {
        return new Sokoban_Types.Coord(e.x, e.y);
    };
    var checkWinCondition = function (s) {
        var $64 = Data_Eq.eq(Data_Eq.eqArray(Sokoban_Types.eqCoord))(Data_Array.sort(Sokoban_Types.ordCoord)(Data_Functor.map(Data_Functor.functorArray)(entityToCoord)(s.world.bags)))(Data_Array.sort(Sokoban_Types.ordCoord)(Data_Functor.map(Data_Functor.functorArray)(entityToCoord)(s.world.areas)));
        if ($64) {
            var $65 = (s.currentLevel + 1 | 0) === Levels.numLevels;
            if ($65) {
                return resetGame;
            };
            var $66 = {};
            for (var $67 in s) {
                if ({}.hasOwnProperty.call(s, $67)) {
                    $66[$67] = s[$67];
                };
            };
            $66.world = Sokoban_Level.createWorld(Levels["levels"][s.currentLevel + 1 | 0]);
            $66.currentLevel = s.currentLevel + 1 | 0;
            return $66;
        };
        return s;
    };
    var checkCanMove = function (s) {
        var $69 = {};
        for (var $70 in s) {
            if ({}.hasOwnProperty.call(s, $70)) {
                $69[$70] = s[$70];
            };
        };
        $69.canMove = Data_Eq.eq(Sokoban_Types.eqCoord)(s.world.soko.nextPos)(new Sokoban_Types.Coord(s.world.soko.x, s.world.soko.y));
        return $69;
    };
    if (state.canMove) {
        return (function ($89) {
            return checkWinCondition(checkCanMove(updateBags($89)));
        })(updateSoko(state));
    };
    return (function ($90) {
        return checkCanMove(interpolateBags($90));
    })(interpolateSoko(state));
};
var $$eval = function (keyLeft) {
    return function (keyRight) {
        return function (keyUp) {
            return function (keyDown) {
                return function (keySpace) {
                    return function (state) {
                        var verticalDir = function (v) {
                            return function (v1) {
                                if (v && !v1) {
                                    return Sokoban_Types.UP.value;
                                };
                                if (!v && v1) {
                                    return Sokoban_Types.DOWN.value;
                                };
                                return Sokoban_Types.NONE.value;
                            };
                        };
                        var horizontalDir = function (v) {
                            return function (v1) {
                                if (v && !v1) {
                                    return Sokoban_Types.LEFT.value;
                                };
                                if (!v && v1) {
                                    return Sokoban_Types.RIGHT.value;
                                };
                                return Sokoban_Types.NONE.value;
                            };
                        };
                        var getDirection = function (v) {
                            return function (v1) {
                                if (v1 instanceof Sokoban_Types.NONE) {
                                    return v;
                                };
                                if (v instanceof Sokoban_Types.NONE) {
                                    return v1;
                                };
                                return Sokoban_Types.NONE.value;
                            };
                        };
                        if (keySpace) {
                            var $80 = {};
                            for (var $81 in state) {
                                if ({}.hasOwnProperty.call(state, $81)) {
                                    $80[$81] = state[$81];
                                };
                            };
                            $80.world = Sokoban_Level.createWorld(Levels["levels"][state.currentLevel]);
                            return $80;
                        };
                        return updateGame((function () {
                            var $83 = {};
                            for (var $84 in state) {
                                if ({}.hasOwnProperty.call(state, $84)) {
                                    $83[$84] = state[$84];
                                };
                            };
                            $83.direction = getDirection(horizontalDir(keyLeft)(keyRight))(verticalDir(keyUp)(keyDown));
                            return $83;
                        })());
                    };
                };
            };
        };
    };
};
var main = function __do() {
    var v = PrestoDOM_Util.render(world)(resetGame)();
    return Control_Apply.applySecond(Control_Monad_Eff.applyEff)(v.updateState(Control_Apply.apply(FRP_Behavior.applyABehavior(FRP_Event.functorEvent))(Control_Apply.apply(FRP_Behavior.applyABehavior(FRP_Event.functorEvent))(Control_Apply.apply(FRP_Behavior.applyABehavior(FRP_Event.functorEvent))(Control_Apply.apply(FRP_Behavior.applyABehavior(FRP_Event.functorEvent))(Control_Apply.apply(FRP_Behavior.applyABehavior(FRP_Event.functorEvent))(Data_Functor.map(FRP_Behavior.functorABehavior(FRP_Event.functorEvent))($$eval)(FRP_Behavior_Keyboard.key(37)))(FRP_Behavior_Keyboard.key(39)))(FRP_Behavior_Keyboard.key(38)))(FRP_Behavior_Keyboard.key(40)))(FRP_Behavior_Keyboard.key(32)))(v.stateBeh))(FRP_Event_Time.animationFrame))(Control_Applicative.pure(Control_Monad_Eff.applicativeEff)(Data_Unit.unit))();
};
module.exports = {
    renderGameScreen: renderGameScreen,
    world: world,
    main: main,
    updateGame: updateGame,
    getNextPos: getNextPos,
    interpolate: interpolate,
    resetGame: resetGame,
    "eval": $$eval
};



//////////////////
// WEBPACK FOOTER
// ./output/Sokoban.Main/index.js
// module id = 280
// module chunks = 0